import { ReactNode } from 'react';
import styles from './LoanQuoteBaseField.module.css';
import { LoanQuoteDataFieldCommonProps } from './types';

interface LoanQuoteDataBaseFieldProps extends LoanQuoteDataFieldCommonProps {
  valueElement: ReactNode;
  inputElement?: ReactNode;
  errorMessage?: string;
}

export const LoanQuoteDataBaseField: React.FC<LoanQuoteDataBaseFieldProps> = ({
  inputElement,
  errorMessage,
}) => {
  return (
    <div className={styles.rootContainer}>
      <div>{inputElement}</div>
      {errorMessage ? (
        <div className={styles.errorContainer}>
          <strong>{errorMessage}</strong>
        </div>
      ) : null}
    </div>
  );
};
